import PropTypes from 'prop-types';
import { getReadingInfo, hiddenReadingTypes } from 'utils/readings';

const ReadingItem = ({ activity }) => {
  return Object.keys(activity.value).map((readingType, index) => {
    if (hiddenReadingTypes.includes(readingType)) {
      return null;
    }

    const { className, key, unit, value } = getReadingInfo(
      activity,
      readingType,
    );

    return (
      <span className={className} key={readingType + index}>
        {key}:
        <strong>
          {` ${value}`}
          <nobr>{` ${unit}`}</nobr>
        </strong>
      </span>
    );
  });
};

ReadingItem.propTypes = {
  activity: PropTypes.object.isRequired,
};

export default ReadingItem;
